import { post } from '../../utils/http';

export const refreshAdminToken = () => post(`${process.env.API_AUTH_URL}/admin/refresh`);

export const refreshUserToken = () => post(`${process.env.API_AUTH_URL}/user/refresh`);
